import React from 'react'
import { useParams } from 'react-router-dom'

import { takeWhile } from 'lodash'

import { useQueryParams } from 'reducer/global/hooks'

import style from './style.module.scss'

export function packComponent(Component, canShow, label = undefined) {
  return { Component, canShow, label }
}

function ProgressiveComponents({
  components,
  state = {},
  borderClass = '',
  className = 'gv3'
}) {
  const params = useParams()
  const queryParams = useQueryParams()

  return (
    <div className={`flex flex-column ${className}`}>
      {takeWhile(components, (c) => c.canShow(state, params, queryParams)).map(
        (c, i) => (
          // it's fine to use index as key b/c order doesn't change
          <div key={i}>
            {c.label && (
              <div className="w-100 pv2 b f5 bb accent b--accent">{c.label}</div>
            )}
            <div className={`${borderClass} ${style.Box}`}>
              <c.Component />
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default ProgressiveComponents
